<template>
	<div>
		<div class="nav">
			<div :class="activeName == 'home' ? 'homeNavs' : 'homeNavs nobackground'
				">
				<!-- 2024-7-29去掉重点专题库点击跳转 :href="
								item.uid == 'A705'
									? (item.children[0].children[0].children
											.length > 0
											? '/specialTopic'
											: '/specialTopicNoLeft') +
									  '?uid=' +
									  item.children[0].children[0].uid
									: item.uid == 'A710'
									? '/'
									: item.url
							" -->
				<ul class="fl ul1">
					<li v-for="(item, index) in leftNavList" :key="index">
						<template v-if="item.text == '政策法规库'">
							<a v-if="item.isnav" href="https://edu.drcnet.com.cn/maillist?dt=d"
								:target="item.uid == 'A708' ? '_blank' : ''"
								:class="activeNav(item.text, item.uid)">校长决策参考</a>
							<div v-if="item.uid == 'A705'" class="triangleOne"></div>
						</template>
						<template v-else>
							<a v-if="item.isnav" :href="item.uid == 'A705'
								? 'javascript:void(0);'
								: item.uid == 'A710'
									? '/custom'
									: '/custom' + item.url
								" :target="item.uid == 'A708' ? '_blank' : ''" :class="activeNav(item.text, item.uid)">{{ item.text }}</a>
							<div v-if="item.uid == 'A705'" class="triangleOne"></div>
						</template>
					</li>
					<li v-if="leftNavList.length > 0">
						<a href="https://iap.drcnet.com.cn/custom/specialTopic?uid=A706" :class="activeNav('会议专题', 'A70603')">会议专题</a>
					</li>
				</ul>

				<!-- <ul class="fl ul2">
				<li>
					<a
						href="http://misc.drcnet.com.cn/DRCNet.Users.Web/Author/authorMain.aspx"
						class="navtxt"
						target="_blank"
						>作者专区</a
					>
				</li>
				<li>
					<a
						href="http://misc.drcnet.com.cn/Journal/Default.aspx"
						class="navtxt"
						target="_blank"
						>期刊专区</a
					>
				</li>
				<li>
					<a
						href="/about"
						:class="activeName == 'about' ? 'navtxt on' : 'navtxt'"
						>产品介绍</a
					>
				</li>
				<li>
					<a
						href="https://member.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx"
						class="navtxt"
						target="_blank"
						>会员专区</a
					>
				</li>
				<li>
					<a
						href="http://misc.drcnet.com.cn/help/index.aspx"
						class="navtxt"
						>使用帮助</a
					>
				</li>
			</ul> -->
			</div>
		</div>

		<div class="nav2 Uplist">
			<div class="homeNavs2">
				<upListCustom v-if="isMoblie == false" />
			</div>
		</div>
	</div>
</template>
<script>
import { getNav } from '../../api/home';
import { mapMutations } from 'vuex';
import upList from './upList';
import upListCustom from './upList/custom.vue';
export default {
	name: 'homeNav',
	components: { upList, upListCustom },
	mixins: [],
	props: {},
	data() {
		return {
			activeName: this.$route.name,
			leftNavList: [],
			isMoblie: false,
			isDrawerOpen: false,
			tableData: [],
		};
	},
	computed: {
		// 判断当前路由是否为 /custom
		isCustomRoute() {
			console.log(this.$route.name === 'custom');

			return this.$route.name === 'custom';
		},
	},
	watch: {
		MobileVerification: {
			handler(to) {
				// console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
		$route: {
			handler(to) {
				this.activeName = this.$route.name;
				this.getNavs();
			},
		},
	},
	mounted() {
		this.activeName = this.$route.name;
		this.getNavs();
	},
	methods: {
		getNavs() {
			// const data = getNav({ version: 'A2' });
			getNav({ uid: 'A7', depth: '0' }).then((res) => {
				this.leftNavList = res.data.data;
				this.updateHomeNavList(res.data.data);
				// localStorage.removeItem('leftNavList');
				// localStorage.setItem(
				// 	'leftNavList',
				// 	JSON.stringify(res.data.data)
				// );
				// for (let index = 0; index < res.data.data.length; index++) {
				// 	const element = res.data.data[index];
				// 	// console.log(element);
				// 	if (element.uid == 'A201') {
				// 		this.tableData = element.children;
				// 	}
				// }
				// console.log(this.leftNavList);
				// console.log(res);
			});
		},
		activeNav(name, uid) {
			// if (name == '首页' && this.activeName == 'home') {
			// 	return 'navtxt on';
			// } else if (this.activeName == 'specialTopicNoLeft') {
			// 	if (name == '马克思主义思想研究') {
			// 		return 'navtxt on';
			// 	} else if (name == '习近平新时代中国特色社会主义思想') {
			// 		return 'navtxt on';
			// 	}
			// }
			if (this.$route.query.uid) {
				// console.log(this.$route.query.uid);
				if (this.$route.query.uid == uid) {
					return 'navtxt on';
				} else {
					if (
						name == '重点专题库' &&
						this.$route.query.uid.startsWith('A705', 0) &&
						this.$route.query.uid.length >= 3 &&
						(this.activeName == 'specialTopic' ||
							this.activeName == 'specialTopicNoLeft')
					) {
						return 'navtxt on';
					} else {
						return 'navtxt';
					}
				}
			} else {
				if (name == '首页' && this.activeName == 'home') {
					return 'navtxt on';
				}
				return 'navtxt';
			}
			// if (name == '首页' && this.activeName == 'home') {
			// 	return 'navtxt on';
			// } else if (
			// 	name == '重点专题库' &&
			// 	(this.activeName == 'specialTopic' ||
			// 		this.activeName == 'specialTopicNoLeft')
			// ) {
			// 	return 'navtxt on';
			// } else if (
			// 	name == '马克思主义思想研究' &&
			// 	this.activeName == 'specialTopicNoLeft'
			// ) {
			// 	return 'navtxt on';
			// } else {
			// 	return 'navtxt';
			// }
		},
		...mapMutations(['updateHomeNavList']),
	},
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
	.nav {
		width: 0 !important;
	}
}

.nav {
	width: 100%;
	min-width: 1200px;
	height: 45px;
	display: flex;
	line-height: 45px;
	background: rgba(195, 0, 0, 1);
}

.nav2 {
	width: 100%;
	min-width: 1200px;
	display: block;

	.homeNavs2 {
		width: 1200px;
		max-width: 1200px;
		margin: 0 auto;
	}
}

.Uplist {
	position: relative;
	// width: 1200px;
	// max-width: 1200px;
	// margin: 0 auto;
	background: linear-gradient(0deg, rgba(238, 239, 242, 0.34), #eeeff2);
	box-shadow: 0px 5px 15px 0px #f4f5f9;
	// height: 101px;
}

.triangleOne {
	width: 0;
	height: 0;
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-bottom: 7px solid #eeeff2;
	position: relative;
	right: -36px;
	top: -7px;
	z-index: 100;
}

.nobackground {}

.homeNavs {
	width: 1200px;
	max-width: 1200px;
	margin: 0 auto;
}

.nav .homeNavs .ul1 li {
	float: left;
}

.nav .homeNavs .ul1 li a {
	color: #fff;
	padding-right: 25px;
	font-size: 17px;
}

.nav .homeNavs .ul2 li {
	float: left;
}

.nav .homeNavs .ul2 li a {
	color: #fff;
	padding-right: 26px;
	font-size: 14px;
}

.nav .homeNavs li a:hover,
.nav .homeNavs li a.on {
	color: #ffe400;
}
</style>
<!-- 手机端样式 -->
<style scoped lang="less">
.drawer-button {
	position: fixed;
	top: 20px;
	left: 20px;
	background: transparent;
	border: none;
	cursor: pointer;
	font-size: 24px;
	z-index: 100;
	/* 更高的层级 */
}

.cdcss {
	margin: 10px 0;
	background: #fff;
	position: relative;

	.paddingcss {
		padding: 0 10px;
	}

	.navMoblie {
		border-bottom: 1px solid #ececec;
		position: relative;
		padding-top: 10px;

		span {
			font-size: 24px;
			color: #1a1a1a;
			height: 40px;
			line-height: 40px;
			position: relative;
			display: block;
		}
	}

	.all_menu {
		width: 100%;
		font-size: 18px;
		white-space: nowrap;
		overflow: auto;
		padding: 18px 0;

		a {
			color: #474747;
			padding-left: 15px;
			padding-right: 15px;
			border-right: 1px solid #eaeaea;
			text-decoration: none;
		}

		a:nth-child(1) {
			padding-left: 0px;
		}

		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}

	.one_menu {
		.acss {
			font-size: 20px;
			color: #474747;
			margin: 15px 0;
			display: block;
			background: url(../../assets/special/conlefticon.jpg) no-repeat left 3px;
			height: 15px;
			padding-left: 16px;
		}

		.two_menu {
			a {
				font-size: 18px;
				color: #474747;
				display: block;
				float: left;
				padding: 8px 10px;
				border: 1px solid #f1f1f1;
				border-radius: 20px;
				margin: 5px;
			}
		}

		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}
}
</style>
